"use client"

import {Button} from "@/components/ui/button"
import {Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger} from "@/components/ui/dialog"

import {Loader2, X} from "lucide-react"
import {AuthFormEnum} from "@/constants/auth-enum";
import React, { useState} from "react";
import {Input} from "@/components/ui/input";
import {Label} from "@/components/ui/label";
import {Textarea} from "@/components/ui/textarea";
import {Controller, FieldValues, useForm} from "react-hook-form";
import ReportQueryHooks from "@/http/api/report/ReportQueryHooks";
import toast from "react-hot-toast";


const {useAcceptReport} = new ReportQueryHooks()


export default function ReportCommentFormModal({customButton, modelId}: { customButton: React.ReactNode, modelId: string | number }) {

    const [open, setOpen] = useState(false)
    const {mutate, isPending} = useAcceptReport()
    const {control, handleSubmit} = useForm();

    const formFields = [
        {name: "name", label: "نام", placeholder: "نام خود را وارد کنید", type: "text"},
        {name: "mobile", label: "موبایل", placeholder: "موبایل را وارد کنید", type: "text"},
        {name: "email", label: "ایمیل", placeholder: "ایمیل را وارد کنید", type: "text"},
        {name: "title", label: "عنوان", placeholder: "عنوان را وارد کنید", type: "text"},
        {name: "content", label: "محتوا", placeholder: "محتوا را وارد کنید", type: "textarea"}
    ];


    const handleClose = () => {
        setOpen(false)
    }

    const onSubmitHandler = (values: any) => {
        if (values) {
            mutate({
                ...values,
                model_id: modelId,
                model: "product"
            }, {
                onSuccess: onSuccessHandler
            })
        }
    }

    const onSuccessHandler = (response: FieldValues) => {
        if (response.statusCode === 200) {
            toast.success(response.message , {position: "top-center"})
            setOpen(false)
        }
    }

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
                {customButton ? customButton : <Button>{AuthFormEnum.register}</Button>}
            </DialogTrigger>
            <DialogContent className="max-w-md md:max-w-xl !rounded-2xl" dir="ltr">
                <DialogHeader className="flex border-b flex-row relative items-center justify-between">
                    <DialogTitle
                        className={"bg-white text-sm border-0 z-10 text-end w-11/12 gap-3 flex items-center flex-row-reverse"}>
                        <span>
                            گزارش
                        </span>
                    </DialogTitle>
                    <Button variant="none" size="icon" className="rounded-full absolute right-1 top-1"
                            onClick={handleClose}>
                        <X className="h-4 w-4"/>
                    </Button>
                </DialogHeader>

                <div dir={"rtl"} className={"w-full flex flex-wrap items-center justify-center px-5"}>
                    <div className="relative mb-6 w-full">
                        <div className={"w-full flex flex-wrap items-center justify-center space-y-2 my-5"}>

                            <form onSubmit={handleSubmit(onSubmitHandler)} className={"w-full flex flex-wrap gap-y-5"}>
                                {formFields.map(({name, label, placeholder, type}) => (
                                    <Label key={name} className="w-full flex flex-wrap gap-y-3" htmlFor={name}>
                                        <div className="w-full flex flex-wrap">
                                            {label}
                                            <span className="text-red-500">*</span>
                                        </div>
                                        <Controller
                                            name={name}
                                            control={control}
                                            render={({field}) =>
                                                type === "textarea" ? (
                                                    <Textarea {...field} className="border-gray-200"
                                                              placeholder={placeholder}/>
                                                ) : (
                                                    <Input {...field} placeholder={placeholder}/>
                                                )
                                            }
                                        />
                                    </Label>
                                ))}
                                <div className={"w-full flex flex-wrap "}>
                                    <Button variant={"default"} className={"w-full flex h-12"}>
                                        {isPending ? <Loader2 className={"animate-spin"}/> : "ثبت گزارش"}
                                    </Button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>


            </DialogContent>
        </Dialog>
    )
}

